import { cn } from '@/lib/utils';

const statusStyles: Record<string, { badge: string; dot: string; label: string }> = {
  active: { badge: 'bg-[#DCFCE7] text-[#166534]', dot: 'bg-[#16A34A]', label: 'Active' },
  due_soon: { badge: 'bg-[#FEF9C3] text-[#854D0E]', dot: 'bg-[#CA8A04]', label: 'Due soon' },
  overdue: { badge: 'bg-[#FEE2E2] text-[#991B1B]', dot: 'bg-[#DC2626]', label: 'Overdue' },
  paused: { badge: 'bg-[#E0E7FF] text-[#3730A3]', dot: 'bg-[#4F46E5]', label: 'Paused' },
  draft: { badge: 'bg-bg-subtle text-text-secondary', dot: 'bg-text-muted', label: 'Draft' },
  renewed: { badge: 'bg-[#DCFCE7] text-[#166534]', dot: 'bg-[#16A34A]', label: 'Renewed' },
  archived: { badge: 'bg-bg-subtle text-text-secondary', dot: 'bg-text-muted', label: 'Archived' },
  sent: { badge: 'bg-[#DCFCE7] text-[#166534]', dot: 'bg-[#16A34A]', label: 'Sent' },
  delivered: { badge: 'bg-[#DCFCE7] text-[#166534]', dot: 'bg-[#16A34A]', label: 'Delivered' },
  failed: { badge: 'bg-[#FEE2E2] text-[#991B1B]', dot: 'bg-[#DC2626]', label: 'Failed' },
  pending: { badge: 'bg-[#FEF9C3] text-[#854D0E]', dot: 'bg-[#CA8A04]', label: 'Pending' },
};

export function StatusBadge({
  status,
  className,
}: {
  status: string;
  className?: string;
}) {
  const key = status.toLowerCase().replace(/\s+/g, '_');
  const known = statusStyles[key] ?? statusStyles[status];
  const s = known ?? {
    badge: 'bg-bg-subtle text-text-secondary',
    dot: 'bg-text-muted',
    label: status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, ' '),
  };
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium',
        s.badge,
        className,
      )}
    >
      <span className={cn('h-1.5 w-1.5 rounded-full', s.dot)} />
      {s.label}
    </span>
  );
}
